export default [
  {
    label: 'Not Onboarded',
    value: 'not_onboarded',
  },
  {
    label: 'Onboarded',
    value: 'onboarded',
  },
  {
    label: 'Linked Banking',
    value: 'bank_linked',
  },
];
